<app-breadcrumb [master]="'Partnerzy'" [parentName]="'Zablokowane NIP'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">
    <mat-form-field class="list-filter">
      <mat-label>NIP</mat-label>
      <input matInput placeholder="NIP" name="nip" [(ngModel)]="initialFilters.nip">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Pełna nazwa</mat-label>
      <input matInput placeholder="Pełna nazwa" name="businessName" [(ngModel)]="initialFilters.businessName">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Ulica</mat-label>
      <input matInput placeholder="Jana Pawła II" name="contains$street" [(ngModel)]="initialFilters.contains$street">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Numer budynku</mat-label>
      <input matInput placeholder="12G" name="houseNumber" [(ngModel)]="initialFilters.houseNumber">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Numer mieszkania</mat-label>
      <input matInput placeholder="135" name="apartmentNumber" [(ngModel)]="initialFilters.apartmentNumber">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Poczta</mat-label>
      <input matInput placeholder="Warszawa" name="contains$postCity" [(ngModel)]="initialFilters.contains$postCity">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Kod pocztowy</mat-label>
      <input matInput placeholder="01-001" name="zipCode" [(ngModel)]="initialFilters.zipCode">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Miejscowość</mat-label>
      <input matInput placeholder="Warszawa" name="contains$city" [(ngModel)]="initialFilters.contains$city">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Powiat</mat-label>
      <input matInput placeholder="Warszawa" name="contains$district" [(ngModel)]="initialFilters.contains$district">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Gmina</mat-label>
      <input matInput placeholder="Warszawa" name="contains$commune" [(ngModel)]="initialFilters.contains$commune">
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'address_state'"
      [label]="'Województwo'" class="list-filter"
      [(ngModel)]="initialFilters.in$state" name="in$state"
    ></app-dict>
  </form>

  <div class="list-buttons">
    <button *ngIf="(userPermissions | async).partner.write"  (click)="addBlockedNip()" mat-stroked-button color="primary">
      <mat-icon>add</mat-icon> <span> Dodaj </span>
    </button>

    <div class="right-list-buttons">
      <button *ngIf="(userPermissions | async).partner.read_report" (click)="downloadReport()"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span>
      </button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element"> {{element.nip}} </td>
    </ng-container>

    <ng-container matColumnDef="bussinessName">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element"> {{element.businessName}} </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdBy?.username }}
      </td>
    </ng-container>

    <ng-container matColumnDef="regional">
      <th mat-header-cell *matHeaderCellDef> Regionalny </th>
      <td mat-cell *matCellDef="let element">
        {{ element.assetsRegional?.fullName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).partner.admin_root" mat-menu-item (click)="delete(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
